<template>
<div class="chapter">
<div class="inner_page">
<a id="pagevii">
<h2 class="fmtitle1">List of Maps and Plates</h2>
<h3 class="sec1a">Maps</h3>
<p class="noindent">The fortresses of northern France and the southern Netherlands, 1745</p>
<p class="noindent">The battle of Fontenoy, 11 May 1745</p>
<h3 class="sec1a">Plates</h3>
<p class="noindent">Maria-Theresa, Empress of Austria, Queen of Hungary and Bohemia.</p>
<p class="noindent">Maurice de Saxe, Marshal of France.</p>
<p class="noindent">William Augustus, Duke of Cumberland.</p>
<p class="noindent">King Louis XV of France.</p>
<p class="noindent">Lieutenant General Sir John Ligonier.</p>
<p class="noindent">British infantry advancing, <em class="italic">c</em>.1745. A still from the excellent Stanley Kubrick film <em class="italic">Barry Lyndon</em> (1975).</p>
<p class="noindent">French artillery in action, <em class="italic">c</em>.1745.</p>
<p class="noindent">A French contemporary map of the battle of Fontenoy. Although some details are indistinct, the three-sided column of Cumberland’s infantry can be seen breaking into the French position.</p>
<p class="noindent">The siege of Tournai, 1745 (previously thought to represent the 1709 siege by Marlborough).</p>
<p class="noindent">Tournai, rebuilt by Vauban, besieged by Saxe, 1745.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?3bcd27f1